import type { ReactNode } from "react";

// ── StatusPill ─────────────────────────────────────────────────────

export function StatusPill({ status }: { status: string }) {
  return (
    <span className={`status-pill ${status}`}>
      {status.replace("_", " ")}
    </span>
  );
}

// ── MetricCard ─────────────────────────────────────────────────────

export function MetricCard({
  icon,
  label,
  value,
}: {
  icon: ReactNode;
  label: string;
  value: string;
}) {
  return (
    <div className="metric-card">
      {icon}
      <span>
        <strong>{value}</strong>
        <small>{label}</small>
      </span>
    </div>
  );
}

// ── ContentPanel ───────────────────────────────────────────────────

export function ContentPanel({
  children,
  eyebrow,
  title,
}: {
  children: ReactNode;
  eyebrow: string;
  title: string;
}) {
  return (
    <section className="content-panel">
      <div className="panel-heading compact">
        <div>
          <p className="eyebrow">{eyebrow}</p>
          <h2>{title}</h2>
        </div>
      </div>
      {children}
    </section>
  );
}

// ── Avatar initials ────────────────────────────────────────────────

export function Avatar(name: string) {
  return name
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

// ── File count label ──────────────────────────────────────────────

export function fileCountLabel(count: number) {
  return count <= 0 ? "No files yet" : `${count} ${count === 1 ? "file" : "files"}`;
}

// ── Status label ───────────────────────────────────────────────────

export function statusLabel(status: string) {
  return status === "archive" ? "Archived" : "Active";
}